"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MATIC_CONFIG = exports.PolygonConfig = void 0;
const network_enum_1 = require("../enums/network.enum");
const network_config_1 = require("./network.config");
class PolygonConfig extends network_config_1.NetworkConfig {
    constructor() {
        super(network_enum_1.Network.Polygon, 137, {}, {});
    }
}
exports.PolygonConfig = PolygonConfig;
exports.MATIC_CONFIG = new PolygonConfig();
//# sourceMappingURL=polygon.config.js.map